
const resolveEntityName = (entry) => {
  if (!entry) return '';
  if (typeof entry === 'string') return entry;
  return entry.name || entry.entityName || entry.title || '';
};

const toMembershipNames = (memberships = []) => memberships
  .map((entry) => resolveEntityName(entry?.entity || entry))
  .filter(Boolean);

const UserProfileModal = ({ user, isOpen, isLoading, error, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">User profile</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
          </div>
          <div className="modal-body">
            {isLoading ? (
              <p className="text-muted mb-0">Loading profile...</p>
            ) : error ? (
              <div className="alert alert-danger mb-0">{error}</div>
            ) : !user ? (
              <p className="text-muted mb-0">No user selected.</p>
            ) : (
              <div className="d-grid gap-3">
                <div>
                  <h6 className="mb-1">{user.name || '—'}</h6>
                  <div className="text-muted small">{user.email || 'No email'} • {user.phone || 'No phone'}</div>
                </div>
                <div className="row g-3">
                  <div className="col-md-6"><strong>Account type:</strong> {user.accountType || '—'}</div>
                  <div className="col-md-6"><strong>Primary role:</strong> {user.role || '—'}</div>
                  <div className="col-md-6"><strong>Status:</strong> {user.enabled === false ? 'Disabled' : 'Enabled'}</div>
                  <div className="col-md-6"><strong>Archived:</strong> {user.archived ? 'Yes' : 'No'}</div>
                  <div className="col-md-6"><strong>Joined:</strong> {user.joinedAt ? new Date(user.joinedAt).toLocaleString() : '—'}</div>
                </div>

                <div>
                  <p className="mb-1 fw-semibold">All roles</p>
                  <div className="d-flex flex-wrap gap-1">
                    {(user.roles || []).length ? (user.roles || []).map((role) => (
                      <span key={role} className="badge text-bg-light border">{role}</span>
                    )) : <span className="text-muted small">No roles</span>}
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-4">
                    <strong>Organization:</strong> {toMembershipNames(user.organizations).join(', ') || resolveEntityName(user.organization) || '—'}
                  </div>
                  <div className="col-md-4">
                    <strong>Club:</strong> {toMembershipNames(user.clubs).join(', ') || resolveEntityName(user.club) || '—'}
                  </div>
                  <div className="col-md-4">
                    <strong>Community:</strong> {toMembershipNames(user.communities).join(', ') || resolveEntityName(user.community) || '—'}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal;
